import {Component, AfterViewInit, OnInit, EventEmitter, Output} from '@angular/core';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
// import { ROUTES_EN, ROUTES_FA, ROUTESUSER_EN, ROUTESUSER_FA } from './menu-items';
import {RouteInfo} from './sidebar.metadata';
import {Router, ActivatedRoute} from '@angular/router';
import {AuthServerProvider} from '../../core/auth/auth-jwt.service';
// import {DoctorService} from '../../entities/doctor/doctor.service';
import {AccountService} from '../../singelton/account.service';
import {LoginService} from '../../core/login/login.service';
import {ROUTES_ADMIN, ROUTES_CLIENT, ROUTES_USER, ROUTES_USER_LEVEL2} from "./menu-items";
import {HttpErrorResponse, HttpHeaders, HttpResponse} from "@angular/common/http";
import {IFileObject} from "../model/file-object.model";
import {FileObjectService} from "../../entities/file/file-object.service";
import {EmployeeService} from "../../core/employee/employee.service";
import {Employee, IEmployee} from "../model/employee.model";
import {ImpersonatePopupComponent} from "./impersonate.popup.component";
import {SettingPackageService} from "../../singelton/settingPackage.service";
import {ISettingPackage} from "../model/settingPackage.model";
import {
  CLIENT_MANAGER_SHOW, SHOW_ACCOUNTING, SHOW_PROJECT_MNG, SHOW_STORE, SHOW_SUPPORT, SHOW_TICKET,
  SHOW_VOIP
} from "../../app.constants";
import {EventService} from "../../singelton/event.service";
import {ISetting, Setting} from "../model/setting.model";
import {SettingService} from "../../entities/setting/setting.service";
import {canAccessFactorWorkflowKartabl} from "../util/factor-workflow-access.util";
import {FeatureFlagsService} from "../../singelton/feature-flags.service";

declare var $: any;

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html'
})
export class SidebarComponent implements OnInit {
  @Output() toggleSidebar = new EventEmitter<void>();

  showMenu = 'user';
  showSubMenu = '';
  lang: any;
  userId: string;

  fileObjectsProfile: IFileObject[] = [];
  profileImgSrc: any;
  employee: IEmployee = new Employee();

  firstName: string;

  lastName: string;


  menu_dashboard_title: any = 'دشبورد';
  menu_dashboard_sale: any = 'گزارش فروش محصولات';
  menu_coding_title: any = 'تعاریف پایه';
  menu_karbord_title: any = 'فروش و بازاریابی';
  menu_report_title: any = 'گزارش ها';
  menu_ticket_title: any = 'تیکت ها';
  menu_supporting_title: any = 'خدمات پس از فروش';
  menu_supporting_title_actions: any = 'آخرین فعالیت قراردادها';

  menu_project_title: any = 'مدیریت پروژه';
  menu_accounting_title: any = 'مالی پروژه';
  menu_resources_title: any = 'منابع';
  menu_accounting_title_prefactor: any = 'پیش‌فاکتور پروژه';
  menu_accounting_title_factors: any = 'فاکتور پروژه';
  menu_accounting_title_incomings: any = 'دریافت و پرداخت';
  menu_accounting_title_costs: any = 'هزینه‌ها';
  menu_resources_title_suppliers: any = 'پیمانکاران';
  menu_resources_title_installers: any = 'نصاب‌ها';
  menu_restore_title: any = 'مدیریت سیستم';
  menu_store_title: any = 'فروش کالا و انبار';
  menu_store_title_orders: any = 'کارتابل فروش کالا';
  menu_store_title_orders_buy: any = 'خرید کالا (ورود انبار)';
  menu_karbord_title_contract: any = 'قرارداد ها';
  menu_karbord_title_file: any = 'فایل ها';
  menu_karbord_title_file_share_report: any = 'گزارش ارسال فایل به مشتری';
  menu_karbord_title_salescycle: any = 'فروش در دست';
  menu_karbord_title_phone: any = 'مخاطبین';
  menu_karbord_title_project: any = 'پروژه ها';
  menu_karbord_title_customer: any = 'مشتریان';
  menu_karbord_title_customer_archive: any = 'مشتریان آرشیو شده';
  menu_karbord_title_customer_delete: any = 'مشتریان حذف شده';
  menu_karbord_title_project_delete: any = 'پروژه های حذف شده';
  menu_karbord_title_project_mng: any = 'کنترل پروژه';
  menu_karbord_title_note: any = 'یادداشت ها';
  menu_karbord_title_sales_during: any = 'فروش در دست';

  menu_report_title_project: any = 'گزارش پروژه‌ها';
  menu_report_title_salescycle: any = 'گزارش قیف فروش';
  menu_report_title_personel: any = 'گزارش عملکرد نیروها';
  menu_report_title_transaction: any = 'لیست پیگیری‌ها و سرنخ‌ها';
  menu_report_title_voip: any = 'گزارش تماس ها';
  menu_report_title_products: any = 'گزارش فروش کالا';
  menu_report_title_daily: any = 'گزارش دوره‌ای';

  menu_project_title_items: any = 'فازها و پیشرفت';
  menu_project_title_task: any = 'وظایف';
  menu_project_title_list: any = 'پروژه‌ها';
  menu_project_title_report: any = 'گزارش پروژه‌ها';

  menu_factor_workflow_all: any = 'همه فرایندهای فاکتور پروژه';
  menu_factor_workflow_kartabl: any = 'کارتابل تأیید فاکتور پروژه';
  menu_factor_workflow_steps: any = 'مراحل فرایند فاکتور پروژه';

  menu_coding_title_position: any = 'سمت ها';
  menu_coding_title_fieldactivity: any = 'زمینه های کاری';
  menu_coding_title_actiontype: any = 'نوع فعالیت ها';
  menu_coding_title_phonetype: any = 'نوع تلفن ها';
  menu_coding_title_connector: any = 'معرف ها';
  menu_coding_title_department: any = 'دفترهای کاری';
  menu_coding_title_introduction: any = 'نحوه آشنایی';
  menu_coding_title_sales_step: any = 'مراحل چرخه های فروش';
  menu_coding_title_project_step: any = 'تعریف فازهای پروژه';
  menu_admin_client: any = 'مدیریت کلاینت ها';
  menu_admin_personnel: any = 'مدیریت کاربران';
  menu_admin_impersonate: any = 'جعل کاربر';
  menu_admin_audit: any = 'وقایع ثبت شده';
  menu_dashboard_main: any = 'دشبورد مدیریت';
  menu_followups_mine: any = 'پیگیری های من';
  menu_advanced_search: any = 'جستجوی پیشرفته';
  menu_review: any = 'نظرسنجی';
  menu_group: any = 'گروه ها';
  menu_calendar_group: any = 'تقویم گروهی';
  menu_report_products_alt: any = 'گزارش فروش محصولات';
  menu_ai_title: any = 'هوش مصنوعی';
  menu_ai_smart_workspace: any = 'میزکار هوشمند';
  menu_ai_smart_report: any = 'گزارش هوشمند';
  menu_report_title_agent: any = 'گزارش هوشمند';

  public sidebarnavItems: any[];

  // business_tyep: any = BUSINESS_TYPE;
  show_ticket: any = SHOW_TICKET;
  show_store: any = SHOW_STORE;
  show_support: any = SHOW_SUPPORT;
  show_voip: any = SHOW_VOIP;
  show_project_mng: any = SHOW_PROJECT_MNG;
  show_accounting: any = SHOW_ACCOUNTING;
  client_manager_show: any = CLIENT_MANAGER_SHOW;

  syncFeatureFlags() {
    const f = this.featureFlags.flags;
    this.show_ticket = f.showTicket;
    this.show_store = f.showStore;
    this.show_support = f.showSupport;
    this.show_voip = f.showVoip;
    this.show_project_mng = f.showProjectMng;
    this.show_accounting = f.showAccounting;
    this.client_manager_show = f.clientManagerShow;
  }

  // this is for the open close
  addExpandClass(element: any) {
    if (element === this.showMenu) {
      this.showMenu = '0';
    } else {
      this.showMenu = element;
    }
  }

  addActiveClass(element: any) {
    if (element === this.showSubMenu) {
      this.showSubMenu = '0';
    } else {
      this.showSubMenu = element;
    }
  }

  settingPackages: ISettingPackage[];
  settings: ISetting[];
  setting: ISetting = new Setting();

  constructor(private modalService: NgbModal,
              private router: Router,
              public employeeService: EmployeeService,
              private route: ActivatedRoute,
              private eventService: EventService,
              private authService: AuthServerProvider, public accountService: AccountService
    , private fileObjectService: FileObjectService,
              private settingService: SettingService,
              public settingPackageService: SettingPackageService,
              private featureFlags: FeatureFlagsService) {

    this.syncFeatureFlags();
    this.accountService.identity().then(d => {

      this.firstName = d.firstName;
      this.lastName = d.lastName;
      this.userId = d.id;
      this.loadImgProfile();
    });
    this.eventService.changeSettingEvantAdd.subscribe((data) => {
      // alert(' chang ----- -- >>   ' + JSON.stringify(data));
      this.featureFlags.load();
      setTimeout(() => this.syncFeatureFlags(), 300);
      this.loadSettings();
    });

  }


  // End open close
  ngOnInit() {
    this.accountService.identity().then(identi => {

      if (identi.authorities.find(role => role === 'ROLE_ADMIN')) {
        // this.sidebarnavItems = ROUTES.filter(sidebarnavItem => sidebarnavItem);
        this.sidebarnavItems = ROUTES_ADMIN.filter(sidebarnavItem => sidebarnavItem);

        // } else if (identi.authorities.find(role => role === 'KARBORD_MENU')) {
      } else if (identi.authorities.find(role => role === 'ROLE_USER')) {
        // } else if (identi.authorities.find(role => role === 'ROLE_ADMIN')) {
        // this.sidebarnavItems = ROUTES.filter(sidebarnavItem => sidebarnavItem);
        this.sidebarnavItems = ROUTES_USER.filter(sidebarnavItem => sidebarnavItem);
      } else if (identi.authorities.find(role => role === 'ROLE_CLIENT')) {
        this.sidebarnavItems = ROUTES_CLIENT.filter(sidebarnavItem => sidebarnavItem);

      } else {
        this.sidebarnavItems = ROUTES_USER_LEVEL2.filter(sidebarnavItem => sidebarnavItem);


      }
    })
    this.lang = sessionStorage.getItem('lang');
// this.loadAll();

  }

  setSidebar() {

    this.accountService.identity().then(identi => {

      // if (identi.authorities.find(role => role === 'ROLE_ADMIN')) {
      //   // this.sidebarnavItems = ROUTES.filter(sidebarnavItem => sidebarnavItem);
      //   this.sidebarnavItems = ROUTES_ADMIN.filter(sidebarnavItem => sidebarnavItem);
      //
      //   // } else if (identi.authorities.find(role => role === 'KARBORD_MENU')) {
      // } else if (identi.authorities.find(role => role === 'ROLE_USER')) {
      //   // } else if (identi.authorities.find(role => role === 'ROLE_ADMIN')) {
      //   // this.sidebarnavItems = ROUTES.filter(sidebarnavItem => sidebarnavItem);
      //   this.sidebarnavItems = ROUTES_USER.filter(sidebarnavItem => sidebarnavItem);
      // } else if (identi.authorities.find(role => role === 'ROLE_CLIENT')) {
      if (this.setting.part === 'project') {
        // alert(' in if pr')
        this.sidebarnavItems = ROUTES_CLIENT.filter(sidebarnavItem => sidebarnavItem);
      } else
      if (this.setting.part === 'sales') {
        // alert(' in if sal')

        this.sidebarnavItems = ROUTES_USER.filter(sidebarnavItem => sidebarnavItem);

      }else{

        // this.accountService.identity().then(identi => {

          if (identi.authorities.find(role => role === 'ROLE_ADMIN')) {
            // this.sidebarnavItems = ROUTES.filter(sidebarnavItem => sidebarnavItem);
            this.sidebarnavItems = ROUTES_ADMIN.filter(sidebarnavItem => sidebarnavItem);

            // } else if (identi.authorities.find(role => role === 'KARBORD_MENU')) {
          } else if (identi.authorities.find(role => role === 'ROLE_USER')) {
            // } else if (identi.authorities.find(role => role === 'ROLE_ADMIN')) {
            // this.sidebarnavItems = ROUTES.filter(sidebarnavItem => sidebarnavItem);
            this.sidebarnavItems = ROUTES_USER.filter(sidebarnavItem => sidebarnavItem);
          } else if (identi.authorities.find(role => role === 'ROLE_CLIENT')) {
            this.sidebarnavItems = ROUTES_CLIENT.filter(sidebarnavItem => sidebarnavItem);

          } else {
            this.sidebarnavItems = ROUTES_USER_LEVEL2.filter(sidebarnavItem => sidebarnavItem);


          }
        // })
        // alert(' in else')

        // this.sidebarnavItems = ROUTES_ADMIN.filter(sidebarnavItem => sidebarnavItem);

      }
        // } else {
      //   this.sidebarnavItems = ROUTES_USER_LEVEL2.filter(sidebarnavItem => sidebarnavItem);
      //
      //
      // }
    })
  }


  loadSettings() {
    this.settingService
      .query()
      .subscribe(
        (res: HttpResponse<ISetting[]>) => this.paginateSetting(res.body, res.headers),
        (res: HttpErrorResponse) => this.onError(res.message)
      );
  }


  protected paginateSetting(data: ISetting[], headers: HttpHeaders) {
    this.settings = data;
    // alert('this.settings.le ='+this.settings.length )

    if (this.settings && this.settings.length > 0) {
      // alert(' in if')
      // this.setting = this.settings[this.settings.length-1];
      this.setting = this.settings[0];
      // alert('this.setting ='+this.setting.id )
      // alert('this.setting ='+this.setting.part )
      this.setSidebar();
    }
  }


  loadAll() {
    // alert(' in thisdfds')
    this.settingPackageService
      .query({
        page: 0,
        size: 1,
      })
      .subscribe(
        (res: HttpResponse<ISettingPackage[]>) => {
          this.settingPackages = res.body;

        }
      ),
      (res: HttpErrorResponse) => this.onError(res.message)
    ;
  }


  goToMyProfile() {
    // this.employeeService.findByUserId(this.userId).subscribe((res: HttpResponse<IEmployee>) => {
    //     this.employee = res.body;
    //     this.accountService.identity().then(identi => {
    //
    //       if (identi.authorities.find(role => role === 'ROLE_ADMIN')) {
    //         this.router.navigate(['/admin/empmngupd/' + this.employee.id]);
    this.router.navigate(['/page/calendar']);

    // } else if (identi.authorities.find(role => role === 'KARBORD_MENU')) {
    //   this.router.navigate(['/admin/empmngupd/' + this.employee.id]);
    //
    // } else {
    //   this.router.navigate(['/admin/empmngupd-user/' + this.employee.id]);
    //
    // }
    // });
    //
    // },
    // (res: HttpErrorResponse) => this.onError(res.message)
    // );
  }

  goToImpersonate() {
    const modalRef = this.modalService.open(ImpersonatePopupComponent, {size: 'sm'});
  }

  onSubMenuClick(sidebarnavSubItem: any, event?: Event) {
    this.addActiveClass(sidebarnavSubItem.title);
    if (sidebarnavSubItem.title === this.menu_admin_impersonate) {
      if (event) {
        event.preventDefault();
      }
      this.goToImpersonate();
    }
  }

  isActionOnlyMenuItem(sidebarnavSubItem: any): boolean {
    return sidebarnavSubItem && sidebarnavSubItem.title === this.menu_admin_impersonate;
  }

  loadImgProfile() {
    this.fileObjectService.queryUserProfile({
      page: 0,
      size: 1
    }, this.userId).subscribe(
      (res: HttpResponse<IFileObject[]>) => this.onSuccessProfile(res.body, res.headers),
      (res2: HttpResponse<any>) => this.onError(res2.body)
    );
  }

  private onSuccessProfile(data, headers) {
    this.fileObjectsProfile = data;
    // this.totalItems = headers.get('X-Total-Count');
    if (this.fileObjectsProfile && this.fileObjectsProfile.length > 0) {
      this.profileImgSrc = this.fileObjectsProfile[0].amazonLink;

    }
  }

  protected onError(errorMessage: string) {
  }

  canAccessFactorWorkflowKartabl(): boolean {
    return canAccessFactorWorkflowKartabl(this.accountService);
  }

  logout() {
    // alert(' inside logout');
    this.authService.logout().subscribe();
  }
}
